export default "__VITE_ASSET__CJUvC1bU__"